var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.7619 0H5.2381C2.34667 0 0 2.34667 0 5.2381V38.7619C0 41.6533 2.34667 44 5.2381 44H38.7619C41.6533 44 44 41.6533 44 38.7619V5.2381C44 2.34667 41.6533 0 38.7619 0ZM13.619 16.7619V36.6667H7.33333V16.7619H13.619ZM7.33333 10.9686C7.33333 9.50191 8.59048 8.38095 10.4762 8.38095C12.3619 8.38095 13.5457 9.50191 13.619 10.9686C13.619 12.4352 12.4457 13.619 10.4762 13.619C8.59048 13.619 7.33333 12.4352 7.33333 10.9686ZM36.6667 36.6667H30.381C30.381 36.6667 30.381 26.9657 30.381 26.1905C30.381 24.0952 29.3333 22 26.7143 21.9581H26.6305C24.0952 21.9581 23.0476 24.1162 23.0476 26.1905C23.0476 27.1438 23.0476 36.6667 23.0476 36.6667H16.7619V16.7619H23.0476V19.4438C23.0476 19.4438 25.0695 16.7619 29.1343 16.7619C33.2933 16.7619 36.6667 19.6219 36.6667 25.4152V36.6667Z",
    fill: "#3B457B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.52771ef387891a9b319cfe9aabaf91c7.svg";
export { ForwardRef as ReactComponent };